import { InformationCircleIcon } from '@heroicons/react/24/outline';
import type { NotificationData } from '@mantine/notifications';

export const errorNotificationStyleConfig = {
  icon: <InformationCircleIcon width={18} />,
  style: { backgroundColor: 'red', color: 'white' }
} as NotificationData;
